import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { forwardRef } from 'react';
import { useDraftailComponents } from './context';
var TYPE_PROP_NAME = 'draftailType';
var DEFAULTS = {
  inlineCode: 'code',
  // eslint-disable-next-line react/display-name
  wrapper: function wrapper(_ref) {
    var children = _ref.children;
    return React.createElement(React.Fragment, {}, children);
  }
};
var DraftailCreateElement = forwardRef(function (props, ref) {
  var propComponents = props.components,
    draftailType = props.draftailType,
    originalType = props.originalType,
    parentName = props.parentName,
    rest = _objectWithoutProperties(props, ["components", "draftailType", "originalType", "parentName"]);
  var components = useDraftailComponents(propComponents);
  var type = draftailType;
  var Component = components["".concat(parentName, ".").concat(type)] || components[type] || DEFAULTS[type] || originalType;
  if (propComponents) {
    return React.createElement(Component, _objectSpread({
      ref: ref
    }, rest, {
      components: propComponents
    }));
  }
  return React.createElement(Component, _objectSpread({
    ref: ref
  }, rest));
});
DraftailCreateElement.displayName = 'DraftailCreateElement';
export default function createElement(type, props) {
  var args = arguments;
  var draftailType = props && props.draftailType;
  if (typeof type === 'string' || draftailType) {
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = DraftailCreateElement;
    var newProps = {};
    for (var key in props) {
      if ({}.hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }
    newProps.originalType = type;
    newProps[TYPE_PROP_NAME] = typeof type === 'string' ? type : draftailType;
    createElementArgArray[1] = newProps;
    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    }
    return React.createElement.apply(null, createElementArgArray);
  }
  return React.createElement.apply(null, [type, _objectSpread({}, props)]);
}